import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
declare var document: any;

@Component({
  selector: "app-corporate-home",
  templateUrl: "./corporate-home.component.html",
  styleUrls: ["./corporate-home.component.css"],
})
export class CorporateHomeComponent implements OnInit {
  token: any;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    if (
      window.location.search &&
      window.location.search.includes("target=support")
    ) {
      setTimeout(() => {
        document.getElementById("support").scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }, 500);
    }
  }
}
